import { render } from "./ServiceBooking.vue?vue&type=template&id=6e58958c&scoped=true"
import script from "./ServiceBooking.vue?vue&type=script&lang=js"
export * from "./ServiceBooking.vue?vue&type=script&lang=js"

import "./ServiceBooking.vue?vue&type=style&index=0&id=6e58958c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e58958c"]])

export default __exports__